import React from 'react'

import validation from '../../../validation'

import LinkedProvidersSection from './LinkedProvidersSection'

export default {
  name: 'Pharmacies',
  group: 'Providers',
  validationSchema: validation.object({}),
  Component: ({ caseModel, caseNumber, setModelValue }) => (
    <LinkedProvidersSection
      caseId={caseNumber || caseModel.caseNumber || caseModel.id}
      type="Pharmacy"
      title="Pharmacies"
      setModelValue={setModelValue}
      caseModel={caseModel}
    />
  ),
}
